module.exports = __webpack_public_path__ + "media/images/lock-837322d48ca4ed70cf351ee05449e3dd.svg";